export default "__VITE_ASSET__b7c40a3f__"